import React, { useEffect, useState }  from 'react';
import styled from 'styled-components';
import { ButtonBack, ButtonNext, CarouselProvider, Dot, Slide, Slider } from "pure-react-carousel";
import 'pure-react-carousel/dist/react-carousel.es.css';
import { IconChevron } from '../../Assets/IconChevron';
import { Link, useNavigate } from 'react-router-dom';
import { IconSearch } from '../../Assets/IconSearch';
import { GetDataPromise } from '../Functions/SendingData';
import { apiMain } from '../../App';
import { Dictionery } from '../../Data/Dictionery';
import { DateInputWTitle } from '../Inputs/DateInputWTitle';
import { DictioneryPanel } from '../../Data/DictioneryPanel';
import { IconCalender } from '../../Assets/contacts/IconCalender';
import gregorian_en from "react-date-object/locales/gregorian_en";
import gregorian from "react-date-object/calendars/gregorian";
import { DateObject } from 'react-multi-date-picker';
const Styles = styled.div`
  position: relative;
  margin: 0 0 2rem;
  &.rtl {
    direction: ltr;
  }

  * {
    overflow: visible;
  }
  .slideHorizontal___1NzNV,
  .horizontalSlider___281Ls {
    transform: scale(1) !important;
  }
  .carousel {
    * {
        overflow: visible;
    }
    overflow: hidden;
    width: 100%;
    margin: 0 auto;
    background-color: var(--body-1);
    display: flex;
    flex-direction: column;
    position: relative;
    .main-slide{
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      transition: all 0.3s ease-in-out;
      img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          overflow: hidden;
      }
      video {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          overflow: hidden;
      }
    }
    .slider-good-visible {
      .slidetype-1 {
        --anim-time-1: 2s;
        --anim-delay-1: 0.2s;
        .text-img {
          inset: 0;
          opacity: 1;
        }
      }
    }
  }
  .arrow {
    position: absolute;
    top: calc(calc(100% - 46px) / 2);
    padding: 1rem 0.5rem;
    background: #FFFFFFea;
    border-radius: 100px;
    border: none;
    cursor: pointer;
    &::before {
        content: "";
        z-index: -1;
        position: absolute;
        inset: -1px;
        background: linear-gradient(180deg, #E5E5E5 0%, #7F7F7F00 100%);
        border-radius: 100px;
    }
    svg {
        display: block;
    }
    &.left {
        left: calc(var(--universal-pad) / 2);
    }
    &.right {
        right: calc(var(--universal-pad) / 2);
    }
    /* .icon {
        font-size: 2.3rem;
    } */
  }   
  .dots {
    position: absolute;
    bottom: calc(34px + 1rem);
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 4px;
    .dot {
        border: none;
        outline: none;
        width: 8px;
        height: 8px;
        border-radius: 100px;
        background-color: var(--n-grey-1);
        padding: 0;
        transition: all 0.2s ease-in-out;
        &:disabled {
            background-color: var(--prime-1);
            width: 16px;
        }
    }
  }
  .search-box {
    position: absolute;
    inset: auto 25% -34px 25%;
    height: 68px;
    background-color: var(--n-grey-0);
    box-shadow: 0px 24px 40px -14px #00000014;
    border-radius: 100px;
    display: flex;
    gap: 0.5rem;
    align-items: center;
    .row-search {
      display: flex;
      gap: 0rem;
      align-items: center;
      justify-content: space-between;
      align-self: normal;
      padding: 0 1rem;
    }
    &.rtl {
      direction: rtl;
      /* input {
        padding: 1.5rem 2rem 1.5rem 4rem;
      } */
      .search-icon {
        inset: 6px auto 6px 6px;
      }
    }
    .calender {
      fill: var(--n-grey-2);
      width: 24px;
      height: 24px;
      display: block;
    }
    .input {
      border-radius: 100px;
      position: relative;
      .text-input {
        padding: 1.5rem 0;
        width: calc(100% - 2rem);
        min-width: 50px;
        border-radius: 100px;
        outline: none;
        border: none;
      }
      .text-input:focus + .values {
        display: flex;
      }
      .values {
        z-index: 190;
        display: none;
        flex-direction: column;
        background-color: #FFFFFF;
        border-radius: var(--border-radius-2);
        position: absolute;
        inset: 100% 0 auto;
        height: 40vh;
        overflow-y: scroll;
        .value {
          padding: 0.3rem 1rem;
          cursor: pointer;
          &:hover {
            background-color: var(--n-grey-1);
          }
        }
      }
    }
    /* input {
      border: none;
      outline: none;
      border-radius: 100px;
      padding: 1.5rem 4rem 1.5rem 2rem;
      width: calc(100% - 6rem);
      font-weight: 700;
    } */
    .search-icon {
      cursor: pointer;
      position: absolute;
      inset: 6px 6px 6px auto;
      background-color: var(--prime-1);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 14px 12px;
      border-radius: 100px;
      svg {
        display: block;
      }
    }
  }
  @media screen and (max-width:850px) {
    margin: 0 0 calc(3rem + 50px);
    .arrow {
      display: none;
    }
    .search-box {
      inset: auto 1rem -84px;
      flex-direction: column;
      border-radius: 28px;
      height: 120px;
    }
  }
`
export default function SliderWSearch3 (props){
  const {data: dataRaw, lan} = props;
  const [hover, setHover] = useState(false);
  const navigate = useNavigate();
  const data = JSON.parse(dataRaw);
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  let todayValue = new DateObject({calendar: gregorian, locale: gregorian_en});
  todayValue.setFormat("YYYY-MM-DD");
  todayValue.setLocale(gregorian_en)
  todayValue.setCalendar(gregorian)
  const today = todayValue.format("YYYY-MM-DD")
  const [selected, setselected] = useState({});
  const [openCountries, setOpenCountries] = useState(false);
  const [openCities, setOpenCities] = useState(false);
  useEffect(() => {
    getData();
  }, [])
  useEffect(() => {
    getDataCity()
  }, [selected.Country_Id])
  const getData = async(force = false) => {
    let URLparams = new URLSearchParams();
    // URLparams.append("Vi_Name", page)
    let res = await GetDataPromise(`${apiMain}/api/v1/setting/country?${URLparams.toString()}`, force);
    let parsed = JSON.parse(res);
    if((parsed.status && parsed.status !== "error" && parsed.status !== "error-no-internet") || parsed.status === "success"){
      setCountries(parsed.data);
    }
  }
  const getDataCity = async(force = false) => {
    let URLparams = new URLSearchParams();
    URLparams.append("Country_Id", selected.Country_Id)
    let res = await GetDataPromise(`${apiMain}/api/v1/setting/city/select?${URLparams.toString()}`, force);
    let parsed = JSON.parse(res);
    if((parsed.status && parsed.status !== "error" && parsed.status !== "error-no-internet") || parsed.status === "success"){
      setCities(parsed.data);
    }
  }
  const onChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setselected((prev) => {
      let temp = {...prev};
      temp[name] = value;
      return temp
    })
  }
  const goSearch = () => {
    let uparams = new URLSearchParams();
    let url = `/${lan.filename}/tour/`
    if(selected.Country_Id){
      // uparams.append("Country_Id", selected.Country_Id)
      let countrySelected = countries.findIndex(v => v.Country_Id === selected.Country_Id);
      if(countrySelected !== -1){
        url = url + countries[countrySelected].Continent_Url + "/"+ countries[countrySelected].Country_Url;
      }
    }
    if(selected.City_Id){
      // uparams.append("City_Id", selected.City_Id)
      let citySelected = cities.findIndex(v => v.Country_Id === selected.Country_Id);
      if(citySelected !== -1){
        url = url + "/" + cities[citySelected].City_Url;
      }
    }
    let getDate = false
    if(selected.Date_Start !== today && selected.Date_End !== today){
      getDate = true
    }
    if(selected.Date_Start && getDate){
      uparams.append("Date_Start", selected.Date_Start)
    }
    if(selected.Date_End && getDate){
      uparams.append("Date_End", selected.Date_End)
    }
    navigate(`${url}?${uparams.toString()}`)
  }
  const slides = (src, link) => {
    if(!src){
      return;
    }
    let type = src.split(".");
    type = type[type.length - 1];
    let newimage = src;
    if(type !== "mp4"){
        // newimage = src.replace(process.env.REACT_APP_API+"/images", process.env.REACT_APP_CACHE);
    }
    let size = "?size=2000"
    if(window.innerWidth < 850){
        size = "?size=750"
    }
    return(
      <Link to={"/" + lan.filename + link} className="main-slide slidetype-1">
          {
              (type === "mp4" || type === "webm") ? (
                  <video autoPlay loop muted playsInline>
                      <source src={newimage} type={"video/" + type} />
                  </video>
              ) : (
                  <img src={newimage+size} alt={"/" + lan.filename + link}/>
              )
          }
      </Link>
    );
  }
  let height = 28.00;
  if(window.innerWidth < 850){
      height = 89.44;
  }
  let rtl = false;
  if(lan.dir === "rtl"){
    rtl = true;
  }
  let slidesImage = data.Images.map((v, i) => {
    let src=  v.ImageDesktop
    let link = v.link;
    if(window.innerWidth < 850){
        src=  v.ImageMobile
    }
    return (
        <Slide 
            key={i} 
            index={data.Images.length - (i+1)} 
            classNameVisible="slider-good-visible"
            onPointerEnter={() => {
                setHover(true)
            }}
            onPointerMove={() => {
                setHover(true)
            }}
            onPointerLeave={() => {
                setHover(false)
            }}
        >
            {slides(src, link)}
        </Slide>
    )
  })
  let dots = data.Images.map((v, i) => {
    return (
        <Dot
            className="dot"
            key={i}
            slide={rtl ? data.Images.length - (i+1) : i}
        >
    
        </Dot>
    )
  });

  const makeFilter = (dataItems, textSearch = "") => {
    let newDataItems = dataItems;
    if(textSearch === ""){
      return newDataItems;
    }
    newDataItems = dataItems.filter((v) => {
      let searching = v.name.toLowerCase()
      let searchingPhrase = textSearch.toLowerCase()
      return searching.search(searchingPhrase) !== -1
    });
    return newDataItems
  }
  const makeSearchCountries = () => {
    let filterItem = countries.map((v) => {
      return {
        value: v.Country_Id,
        name: (lan.filename !== "fa") ? v.Country_En_Name : v.Country_Name
      }
    });
    let newItems = makeFilter(filterItem, (selected["search-countries"] ? selected["search-countries"] : ""));
    return (
      <div className='input' onBlur={() => setTimeout(() => setOpenCountries(false), 100)}>
        <input 
          className='text-input' 
          placeholder={Dictionery.DistCountry[lan.filename]} 
          type='text' 
          name='search-countries' 
          value={(selected["search-countries"] ? selected["search-countries"] : "")}
          onChange={onChange}
          onClick={() => setOpenCountries(true)}
          
        />
        <div className='values' style={{display: ((openCountries) ? "flex" : "")}}>
          {
            newItems.map((v) => {
              return (
                <div 
                  className='value' 
                  key={v.value} 
                  onClick={() => {
                    onChange({
                      target: {
                        name: "search-countries",
                        value: v.name,
                      }
                    })
                    onChange({
                      target: {
                        name: "Country_Id",
                        value: v.value,
                      }
                    })
                    setOpenCountries(false)
                  }}>
                    {v.name}
                  </div>
              )
            })
          }
        </div>
      </div>
    )
  }
  const makeSearchCities = () => {
    let filterItem = cities.map((v) => {
      return {
        value: v.City_Id,
        name: (lan.filename !== "fa") ? v.City_EnName : v.City_Name
      }
    });
    let newItems = makeFilter(filterItem, (selected["search-cities"] ? selected["search-cities"] : ""));
    return (
      <div className='input' onBlur={() => setTimeout(() => (openCities) ? setOpenCities(false) : "", 150)}>
        <input 
          className='text-input' 
          placeholder={Dictionery.DistCity[lan.filename]} 
          type='text' 
          name='search-cities' 
          value={(selected["search-cities"] ? selected["search-cities"] : "")}
          onChange={onChange}
          onClick={() => setOpenCities(true)}
          
        />
        <div className='values' style={{display: ((openCities) ? "flex" : "")}}>
          {
            newItems.map((v) => {
              return (
                <div 
                  className='value' 
                  key={v.value} 
                  onClick={() => {
                    onChange({
                      target: {
                        name: "search-cities",
                        value: v.name,
                      }
                    })
                    onChange({
                      target: {
                        name: "City_Id",
                        value: v.value,
                      }
                    })
                    setOpenCities(false)
                  }}>
                    {v.name}
                  </div>
              )
            })
          }
        </div>
      </div>
    )
  }
  return (
    <Styles className={' ' + lan.dir}>
      <CarouselProvider
          naturalSlideWidth={100}
          naturalSlideHeight={height}
          totalSlides={data.Images.length}
          playDirection={rtl ? "backward" :"forward" }
          currentSlide={rtl ? data.Images.length - 1 :  0}
          visibleSlides={1}
          isPlaying={(window.innerWidth < 850) ? true : !hover}
          interval={6000}
      >
          <Slider>
              {
                  (rtl) ? slidesImage.reverse() : slidesImage
              }
          </Slider>
          {
            (slidesImage.length === 1) ? "" : (
              <>
                <ButtonNext className="arrow right"><IconChevron className="icon"/></ButtonNext>
                <ButtonBack className="arrow left"><IconChevron className="icon"  style={{rotate: "180deg"}}/></ButtonBack>
                <div className="dots">
                    {
                        (rtl) ? dots.reverse() : dots
                    }
                </div>
              </>
            )
          }
      </CarouselProvider>
      <div className={'search-box ' + lan.dir}>
          <div className='row-search'>
          {makeSearchCountries()}
          {/* {makeSearchCities()} */}
          </div>
          <div className='row-search' style={{justifyContent: "flex-start"}}>
          <IconCalender className={"calender"}/>
          <DateInputWTitle
            title={DictioneryPanel.packagesDict.goDate[lan.filename]}
            name={"Date_Start"}
            value={(selected["Date_Start"]) ? selected["Date_Start"] : ""}
            onchange={onChange}
            style={{width: "120px"}}
            noError={true}
            lan={(lan.filename !== "fa")}
            className={"no-border"}
          />
          <IconCalender className={"calender"}/>
          <DateInputWTitle
            title={DictioneryPanel.packagesDict.backDate[lan.filename]}
            name={"Date_End"}
            value={(selected["Date_End"]) ? selected["Date_End"] : ""}
            onchange={onChange}
            style={{width: "120px",}}
            lan={(lan.filename !== "fa")}
            noError={true}
            className={"no-border"}
          />
          </div>
          {/* <input
            placeholder={data['search-text']}
          /> */}
          <div className='search-icon' onClick={goSearch}>
            <IconSearch/>
          </div>
      </div>
    </Styles>
  )
}

